import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { zip } from 'rxjs/observable/zip';
import { VasAppFacade } from '../../../vas/services/vas-app-facade.service';
import { JobStatusPickerPopoverOptionEnum } from './job-status-picker-popover-option.enum';
import { JobStatusPickerOption } from './job-status-picker-popover-option.model';
import { ActionLoadSuccess, LOAD } from './job-status-picker-popover.actions';

@Injectable()
export class JobStatusPickerPopoverEffects {

    @Effect()
    load$ = this.actions$.ofType(LOAD)
        .switchMap(action => {

            const selectedIds: Array<string> = action.payload || [];
            const options: Array<JobStatusPickerOption> = [];

            return zip(
                this.appFacade.objects.categoryGroup.store.getAll().take(1),
                this.appFacade.objects.jobStatus.store.getAll().take(1)
            ).map(([categoryGroups, jobStatuses]) => {

                categoryGroups
                    .sort((a, b) => a.title.localeCompare(b.title))
                    .forEach(categoryGroup => {

                        const cgOption = {
                            id: categoryGroup.id,
                            title: categoryGroup.title,
                            type: JobStatusPickerPopoverOptionEnum.CATEGORY_GROUP,
                            selected: false,
                            children: jobStatuses
                                .filter(jobStatus => categoryGroup.categories.find(id => jobStatus.id === id))
                                .sort((a, b) => a.sequence - b.sequence)
                                .map(jobStatus => ({
                                    id: jobStatus.id,
                                    title: jobStatus.title,
                                    type: JobStatusPickerPopoverOptionEnum.JOB_STATUS,
                                    selected: !!selectedIds.find(id => jobStatus.id === id),
                                    children: []
                                }))
                        };

                        if (!cgOption.children.length) {
                            return;
                        }

                        options.push(cgOption);
                    });

                // a list of jobStatus ids that have already been included as children of a categoryGroup
                const jobStatusIdsIncluded = options.reduce((p, c) => p.concat(c.children.map(item => item.id)), []);

                jobStatuses
                    .sort((a, b) => a.sequence - b.sequence)
                    .forEach(jobStatus => {

                    if (jobStatusIdsIncluded.find(id => jobStatus.id === id)) {
                        return;
                    }

                    options.push({
                        id: jobStatus.id,
                        title: jobStatus.title,
                        type: JobStatusPickerPopoverOptionEnum.JOB_STATUS,
                        selected: !!selectedIds.find(id => jobStatus.id === id),
                        children: []
                    });
                });

                return new ActionLoadSuccess(options);
            });
        });

    constructor(
        protected actions$: Actions,
        protected appFacade: VasAppFacade
    ) {

    }
}



// WEBPACK FOOTER //
// ./src/app/atoms/job-status-picker-popover/job-status-picker-popover.effects.ts